﻿﻿export interface IDonorLogistics {
    logisticsProvider: string;
    hasTravelWarning: boolean;
    hasCommercialTravelWarning: boolean;
    mapLink: string;
    kidneyPickupDateTime: string;
    kidneyPickupDateTimeBackup: string;
    kidneyPickupDateTimeActual: string;
    kidneyArrivalDateTime: string;
    kidneyArrivalDateTimeBackup: string;
    kidneyArrivalDateTimeActual: string;
    flightRouteOrGround: string;
    flightRouteOrGroundBackup: string;
    flightRouteOrGroundActual: string;
    transportMethodId: number;
    transportMethod: string;
    transportMethodBackup: string;
    transportMethodBackupId: number;
    transportMethodActual: string;
    transportMethodActualId: number;
    transportCost: string;
    transportCostBackup: string;
    transportCostActual: string;
    flightCarrierAndNumber: string;
    flightCarrierAndNumberBackup: string;
    flightCarrierAndNumberActual: string;
    pickupGroundMiles: string;
    pickupGroundMilesBackup: string;
    pickupGroundMilesActual: string;
    dropoffGroundMiles: string;
    dropoffGroundMilesBackup: string;
    dropoffGroundMilesActual: string;
    flightDepartureTime: string;
    flightDepartureTimeTz: string;
    flightDepartureTimeBackup: string;
    flightDepartureTimeBackupTz: string;
    flightDepartureTimeActual: string;
    flightDepartureTimeActualTz: string;
    flightArrivalTime: string;
    flightArrivalTimeTz: string;
    flightArrivalTimeBackup: string;
    flightArrivalTimeBackupTz: string;
    flightArrivalTimeActual: string;
    flightArrivalTimeActualTz: string;
    leg2DepartureTime: string;
    leg2DepartureTimeTz: string;
    leg2DepartureTimeActual: string;
    leg2DepartureTimeActualTz: string;
    leg2DepartureTimeBackup: string;
    leg2DepartureTimeBackupTz: string;
    leg2ArrivalTime: string;
    leg2ArrivalTimeTz: string;
    leg2ArrivalTimeActual: string;
    leg2ArrivalTimeActualTz: string;
    leg2ArrivalTimeBackup: string;
    leg2ArrivalTimeBackupTz: string;
    tenderedToAirlineActual: string;
    tenderedToAirlineActualTz: string;
    recoveredFromAirlineActual: string;
    recoveredFromAirlineActualTz: string;
    deliveryLocation: string;
    deliveredTo: string;
    activeLogisticsPlan: string;
    logisticsPlanNotes: string;
    whichDonorKidney: string;
}
